const ACTIVE_CLS = 'filter-pill shrink-0 px-3 sm:px-4 py-2 text-sm font-medium rounded-xl transition-all bg-blue-600 text-white shadow-lg shadow-blue-500/20';
const INACTIVE_CLS = 'filter-pill shrink-0 px-3 sm:px-4 py-2 text-sm font-medium rounded-xl transition-all bg-th-surface text-th-text-3 hover:text-th-text hover:bg-th-surface-hover border border-transparent hover:border-th-border-2';

export interface FilterItem {
  id: string;
  label: string;
}

export function filterPills(items: FilterItem[], activeId: string): string {
  return `<div class="flex gap-2 mb-6 overflow-x-auto pb-1">${
    items.map(item =>
      `<button data-filter="${item.id}" class="${item.id === activeId ? ACTIVE_CLS : INACTIVE_CLS}">${item.label}</button>`
    ).join('')
  }</div>`;
}

export function setupFilterPills(container: HTMLElement, callback: (filterId: string) => void) {
  container.querySelectorAll('.filter-pill').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = (btn as HTMLElement).dataset.filter!;
      container.querySelectorAll('.filter-pill').forEach(b => {
        b.className = (b as HTMLElement).dataset.filter === id ? ACTIVE_CLS : INACTIVE_CLS;
      });
      callback(id);
    });
  });
}

export function tabButtons(tabs: { id: string; label: string }[], activeId: string): string {
  return `<div class="flex gap-2 mb-6">${
    tabs.map(t =>
      `<button data-tab="${t.id}" class="px-3 sm:px-4 py-2 text-sm font-medium rounded-xl transition-all ${t.id === activeId ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/20' : 'bg-th-surface text-th-text-3 hover:text-th-text hover:bg-th-surface-hover'}">${t.label}</button>`
    ).join('')
  }</div>`;
}

export function setupTabs(container: HTMLElement, callback: (tabId: string) => void) {
  container.querySelectorAll('[data-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = (btn as HTMLElement).dataset.tab!;
      container.querySelectorAll('[data-tab]').forEach(b => {
        const isActive = (b as HTMLElement).dataset.tab === id;
        b.className = `px-3 sm:px-4 py-2 text-sm font-medium rounded-xl transition-all ${isActive ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/20' : 'bg-th-surface text-th-text-3 hover:text-th-text hover:bg-th-surface-hover'}`;
      });
      callback(id);
    });
  });
}
